<template>
  <v-row class="mb-auto" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table show-select @toggle-select-all="selectAll" :multi-sort="false" v-model="selected" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>日志</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn small :color="issearch ? 'error' : 'success'" dark class="mr-2" @click="issearch = !issearch">
              <v-icon>{{issearch ? "mdi-magnify-close" : "mdi-magnify"}}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.RequestAction="{ item }">
          <v-tooltip bottom v-if="item.RequestAction&&item.RequestAction.length > 25">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 150px;"
                class="d-inline-block text-truncate">{{ item.RequestAction }}</span>
            </template>
            <span>{{ item.RequestAction }}</span>
          </v-tooltip>
          <span v-else>{{ item.RequestAction }}</span>
        </template>
        <template v-slot:item.FormURI="{ item }">
          <v-tooltip bottom v-if="item.FormURI&&item.FormURI.length > 25">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 150px;"
                class="d-inline-block text-truncate">{{ item.FormURI }}</span>
            </template>
            <span>{{ item.FormURI }}</span>
          </v-tooltip>
          <span v-else>{{ item.FormURI }}</span>
        </template>
        <template v-slot:item.Body="{ item }">
          <v-tooltip bottom v-if="item.Body&&item.Body.length > 36">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 240px;"
                class="d-inline-block text-truncate">{{ item.Body }}</span>
            </template>
            <span>{{ item.Body }}</span>
          </v-tooltip>
          <span v-else>{{ item.Body }}</span>
        </template>
        <template v-slot:item.UserAgent="{ item }">
          <v-tooltip bottom v-if="item.UserAgent&&item.UserAgent.length > 25">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 150px;"
                class="d-inline-block text-truncate">{{ item.UserAgent }}</span>
            </template>
            <span>{{ item.UserAgent }}</span>
          </v-tooltip>
          <span v-else>{{ item.UserAgent }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  export default {
    components: {
      search,
    },
    data: function () {
      return {
        selected: [],
        headers: [{
          text: "ID",
          value: "Id",
          groupable: false
        },
        {
          text: "User",
          value: "Userer.Username",
        },
        {
          text: "类型",
          value: "Method",
          groupable: false
        },
        {
          text: "方法",
          value: "RequestAction",
        },
        {
          text: "Host",
          value: "Host",
          groupable: false
        },
        {
          text: "FormURI",
          value: "FormURI",
          groupable: false
        },
        {
          text: "FormRefer",
          value: "FormRefer",
          groupable: false
        },
        {
          text: "Body",
          value: "Body",
          groupable: false
        },
        {
          text: "IP",
          value: "Ip",
        },
        {
          text: "IPAddr",
          value: "IpAddr",
        },
        {
          text: "UserAgent",
          value: "UserAgent",
        },
        {
          text: "访问时间",
          value: "CreateAt",
          groupable: false
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          groupable: false
        },
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
      }
    },
    watch: {
      options: {
        handler() {
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          } else {
            this.sortby = "Id";
            this.order = "desc";
          }
          this.initialize();
        },
        deep: true,
      },
    },
    methods: {
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      selectAll(item) {
        this.selected = item.value ? item.items : [];
      },
      delselect(e) {
        if (!confirm("确认删除所有选中项吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true;
          this.$api.delLog({
              id: ids
            }).then((res) => {
              this.loading = false;
              for (let index = 0; index < arrid.length; index++) {
                this.mainData = this.mainData.filter(
                  (item) => item.Id != arrid[index]
                );
              }
              this.countData -= arrid.length;
            }).catch((error) => {
              this.loading = false;
              let message = (error && error.msg) || "删除选中选失败！";
              this.$store.commit("setsnack", { message });
              console.error(error);
            });
        } else {
          this.$store.commit("setsnack", {
            message: "尚未选择任何项目",
            color: "warning",
          });
        }
      },
      initialize() {
        this.loading = true;
        let data = {
          limit: this.limit,
          offset: this.offset,
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        this.$api.getLogs(data).then((res) => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      deleteItem(item) {
        const index = this.mainData.indexOf(item);
        if (confirm("确认删除此项数据吗?")) {
          // Del Item
          const data = {
            id: item.Id,
          };
          this.loading = true;
          this.$api.delLog(data).then((res) => {
            this.loading = false;
            this.mainData.splice(index, 1);
            this.countData--;
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
    },
  };
</script>